/**
 * @description Combination of Leg Card Id, Class and Fare. Coming from query param and used for seat selection first flow.
 */
export type LegCardIdClassAndFare = string;

/**
 * Outbound Query Param used for seat selection first flow. Combination of Leg Card Id, Class and Fare
 *
 * @see {@link LegCardIdClassAndFare}
 * @constant
 */
export const OUTBOUND_LCF: LegCardIdClassAndFare = "outbound_lcf";

/**
 * Return Query Param used for seat selection first flow
 *
 * @constant
 */
export const RETURN_LCF: LegCardIdClassAndFare = "return_lcf";
